import type { Subscription } from '@/core/domain';
import type { SubscriptionRepository } from '../repositories/subscription-repository';

export class GetSubscriptionByUserIdUseCase {
  constructor(private readonly repository: SubscriptionRepository) {}

  execute(userId: string): Promise<Subscription | null> {
    return this.repository.getByUserId(userId);
  }
}
